export default __webpack_public_path__ + "assets/Permit.7828.svg";